import { render, staticRenderFns } from "./cashMoney.vue?vue&type=template&id=22745512"
import script from "./cashMoney.vue?vue&type=script&lang=js"
export * from "./cashMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports